/**
 * Data infrastructure
 */
const liveEndpoint = 'https://orca.kattana.trade/last';
const wsEndpoint = 'wss://orca.kattana.trade/c/w';

const backend = 'https://broker.kattana.trade';
/**
 * Integrations
 */
const ethplorerKey = 'EK-3xec8-JqUVSqG-QuCJo';

export {
  backend,
  ethplorerKey,
  liveEndpoint,
  wsEndpoint,
};
